/* tslint:disable */
/* eslint-disable */
/**
 * IGA Gewinnspiel API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: info@wapp.gmbh
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Pagination,
    PaginationFromJSON,
    PaginationFromJSONTyped,
    PaginationToJSON,
    Price,
    PriceFromJSON,
    PriceFromJSONTyped,
    PriceToJSON,
    PricePaginatedAllOf,
    PricePaginatedAllOfFromJSON,
    PricePaginatedAllOfFromJSONTyped,
    PricePaginatedAllOfToJSON,
} from './';

/**
 * 
 * @export
 * @interface PricePaginated
 */
export interface PricePaginated {
    /**
     * 
     * @type {number}
     * @memberof PricePaginated
     */
    recordsTotal?: number;
    /**
     * 
     * @type {Array<Price>}
     * @memberof PricePaginated
     */
    data: Array<Price>;
}

export function PricePaginatedFromJSON(json: any): PricePaginated {
    return PricePaginatedFromJSONTyped(json, false);
}

export function PricePaginatedFromJSONTyped(json: any, ignoreDiscriminator: boolean): PricePaginated {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'recordsTotal': !exists(json, 'recordsTotal') ? undefined : json['recordsTotal'],
        'data': ((json['data'] as Array<any>).map(PriceFromJSON)),
    };
}

export function PricePaginatedToJSON(value?: PricePaginated | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'recordsTotal': value.recordsTotal,
        'data': ((value.data as Array<any>).map(PriceToJSON)),
    };
}


